import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "d-flex mb-3" }
const _hoisted_3 = { class: "col-3" }

import SystemAlerts from "./Misc/SystemAlerts.vue";
import {BAgency} from "./Fields";
import AgencyOverview from "./AgencyDashboard/AgencyOverview.vue";
import AgencyNotice from "./AgencyDashboard/AgencyNotice.vue";
import AgencySubmission from "./AgencyDashboard/AgencySubmission.vue";
import {ref} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AgencyDashboard',
  setup(__props) {

const agency = ref();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("label", {
        for: "agency",
        class: "align-self-center me-3"
      }, "Select Agency", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(BAgency), {
          modelValue: agency.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((agency).value = $event)),
          "can-clear": false,
          "select-first": true
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createVNode(AgencyNotice, { ori: agency.value }, null, 8, ["ori"]),
    _createVNode(AgencySubmission, { ori: agency.value }, null, 8, ["ori"]),
    _createVNode(AgencyOverview, { ori: agency.value }, null, 8, ["ori"]),
    _createVNode(SystemAlerts)
  ]))
}
}

})